import ShowByRole from 'App/components/ShowByRole';
import { PaymentStatusAlert } from 'domains/Billing/Checkout/components';
import { KycRejectedAlert } from 'domains/NuvemPagoCommons/components/KycRejectedAlert';
import AlertFirstSale from '../AlertFirstSale';
import FacebookConnectionStatusAlert from '../FacebookConnectionStatusAlert';
import NuvemEnvioAdminBlockingAlert from '../NuvemEnvioAdminBlockingAlert';
import TrialMessages from '../TrialMessages';
import UpdateSuggestion from '../UpdateSuggestion';

function NewAlertNotifications() {
  return (
    <>
      <ShowByRole includeRoles="full">
        <>
          <KycRejectedAlert />
          <NuvemEnvioAdminBlockingAlert />
          <TrialMessages />
          <FacebookConnectionStatusAlert />
          <UpdateSuggestion />
        </>
      </ShowByRole>
      <ShowByRole includeRoles="orders">
        <AlertFirstSale />
      </ShowByRole>
      <ShowByRole includeRoles="full">
        <PaymentStatusAlert concept="plan-cost" isExternalContext />
      </ShowByRole>
    </>
  );
}

export default NewAlertNotifications;
